exports.name = 'varec';
exports.host = 'varec.kmdg/';
exports.debug = true;